import {Controller} from "stimulus";


export default class extends Controller {
  static targets = ["partner", "partnerCategory", "referral", "referralCategory", "partnerList", "submit", "label"];

  initialize() {
    this.sending = false;
  }

  toggleReferral(event) {
    if (event.currentTarget.checked) {
      this.addReferral(event.currentTarget)
    }
    else {
      for(let i = 0; i < this.referralTargets.length; i++) {
        if (this.referralTargets[i].dataset.value == event.currentTarget.value) {
          this.referralTargets[i].remove();
        }
      }
    }
  }

  toggleReferralCategory(event) {
    if (event.currentTarget.checked) {
      this.addReferralCategory(event.currentTarget)
    } else {
      for (let i = 0; i < this.referralCategoryTargets.length; i++) {
        if (this.referralCategoryTargets[i].dataset.value == event.currentTarget.value) {
          this.referralCategoryTargets[i].remove();
        }
      }
    }
  }

  addReferral(input) {
    var checkbox = $('<li class="list-group-item clearfix" data-target="referrals.referral" data-action="click->referrals#removeReferral"/>').attr('data-value', input.value);
    checkbox.append($('<div class="pull-left"/>').text(input.dataset.partner));
    checkbox.append($('<div class="pull-right"><button class="btn btn-default btn-sm">Remove</button></div>'));
    checkbox.appendTo($('#referral-partner-list'));
    this.submitTarget.style.display = 'block';
    this.labelTarget.style.display = 'block';
  }

  addReferralCategory(input) {
    var checkbox = $('<li class="list-group-item clearfix" data-target="referrals.referralCategory" data-action="click->referrals#removeReferralCategory"/>').attr('data-value', input.value);
    checkbox.append($('<div class="pull-left"/>').text(input.dataset.partner));
    checkbox.append($('<div class="pull-right"><button class="btn btn-default btn-sm">Remove</button></div>'));
    checkbox.appendTo($('#referral-partner-list'));
    this.submitTarget.style.display = 'block';
    this.labelTarget.style.display = 'block';
  }

  removeReferral(event) {
    for (let i = 0; i < this.partnerTargets.length; i++) {
      if (this.partnerTargets[i].value == event.currentTarget.dataset.value) {
        this.partnerTargets[i].checked = false;
      }
    }
    event.currentTarget.remove();
    if (!this.hasReferralTarget && !this.hasReferralCategoryTarget) {
      this.submitTarget.style.display = 'none';
      this.labelTarget.style.display = 'none';
    }
  }

  removeReferralCategory(event) {
    for (let i = 0; i < this.partnerCategoryTargets.length; i++) {
      if (this.partnerCategoryTargets[i].value == event.currentTarget.dataset.value) {
        this.partnerCategoryTargets[i].checked = false;
      }
    }
    event.currentTarget.remove();
    if (!this.hasReferralTarget && !this.hasReferralCategoryTarget) {
      this.submitTarget.style.display = 'none';
      this.labelTarget.style.display = 'none';
    }
  }

  sendReferrals(event) {
    if (!this.sending) {
      this.sending = true;
      const partners = this.referralTargets.map(x => x.dataset.value);
      const categories = this.referralCategoryTargets.map(x => x.dataset.value);
      let callController = this.application.getControllerForElementAndIdentifier(document.getElementById('call-screen'), 'call');
      callController.sendUpdate({referrals:{partners:partners, partner_categories:categories}});
    }
  }
}